<template>
  <div
    class="remoteKey notranslate"
    ref="remoteKey"
    @click="remoteMobilekey">
    <img v-if="img" :src="img" />
    <div v-else class="defaultImg"><span class="label">OPEN</span></div>
    <div v-if="status" class="remoteStatus">
      <span v-if="status === 'request'" class="loader"></span>
    </div>
    <ToastMessage v-if="toastMessage"
      :locale="locale"
      :message="toastMessage"
      @close="setToastMessage(null)" />
  </div>
</template>

<script>
import ToastMessage from '@/components/Util/ToastMessage'

export default {
  props: [
    'img'
  ],
  components: {
    ToastMessage
  },
  computed: {
    locale () {
      return this.$store.state.system.locale.data
    },
    authInfo () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    getMobilekeyInfo () {
      return this.$store.getters['guest/getMobilekeyInfo']
    }
  },
  data () {
    return {
      toastMessage: null,
      status: null
    }
  },
  methods: {
    getResultData (code) {
      return this.$store.getters['guest/getSmartkeyResultData'](code)
    },
    setToastMessage (message) {
      this.toastMessage = message
    },
    async remoteMobilekey () {
      const getMobilekeyInfo = this.getMobilekeyInfo
      this.status = 'request'
      if (getMobilekeyInfo) {
        this.$store.dispatch('guest/remoteOpenMobileKey', getMobilekeyInfo).then((res) => {
          this.status = null
          if (res && res.status && res.status === 200) {
            const sendResult = res.data && res.data.message
            const ok = sendResult && sendResult.result
            if (ok === "OK") {
              const spaceCodeType = getMobilekeyInfo.spaceCodeType || 'R'
              const openMessage = spaceCodeType === 'R' ? this.locale.smartkey_remotekey_open_R : this.locale.smartkey_remotekey_open_L
              this.setToastMessage(openMessage)
            } else {
              const errorCode = res && res.data && res.data.message && res.data.message.code || 500
              const errorMessage = this.getResultData(errorCode)
              this.setToastMessage(errorMessage)
            }
          } else {
            const errorCode = res && res.message && res.message.code || 500
            const errorMessage = this.getResultData(errorCode)
            this.setToastMessage(errorMessage)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.remoteKey {
  position: relative;
}
.remoteStatus {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90px;
  height: 90px;
  margin-top: -45px;
  margin-left: -45px;
  border-radius: 100%;
  background-color: rgba(0,0,0,0.25);
  z-index: 99;
}
.loader {
  display: block;
  position: relative;
  top: 50%;
  left: 50%;
  width: 64px;
  height: 64px;
  margin-top: -32px;
  margin-left: -32px;
}
.loader::after,
.loader::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background-color: $color-white;
  animation: animloader 2s linear infinite;
  opacity: 0;
}
.loader::after {
  animation-delay: 1s;
}

@keyframes animloader {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
